import { format, parseISO } from "date-fns";

import { IStoreDeposit, IStoreDepositKey } from "src/@types/store-deposit-maintenance";
import { formatBRL } from "@/utils/money";

import {
  DEPOSIT_IDENTITY_SEPARATOR,
  DISPLAY_DATE_FORMAT,
  DISPLAY_TIME_LENGTH,
  EMPTY_CELL,
  ISO_DATE_LENGTH,
  LEGACY_EMPTY_DATE,
  NSU_SUFFIX_SEPARATOR,
} from "./types";

export const text = (value: string | number | null): string =>
  value === null || value === "" ? EMPTY_CELL : String(value);

export const toIsoDate = (value: string): string =>
  value.slice(0, ISO_DATE_LENGTH);

export const formatOperationDate = (value: string): string =>
  format(parseISO(toIsoDate(value)), DISPLAY_DATE_FORMAT);

export const formatAmount = (value: number): string => formatBRL(value);

export const formatChangedAt = (
  changedAt: string | null,
  changedTime: string | null,
): string => {
  if (changedAt === null || toIsoDate(changedAt) === LEGACY_EMPTY_DATE) {
    return EMPTY_CELL;
  }
  const date: string = formatOperationDate(changedAt);
  if (changedTime === null || changedTime === "") return date;
  return `${date} ${changedTime.slice(0, DISPLAY_TIME_LENGTH)}`;
};

export const extractNsuPrefix = (nsu: string): string => {
  const index: number = nsu.indexOf(NSU_SUFFIX_SEPARATOR);
  return index >= 0 ? nsu.substring(0, index) : nsu;
};

export const toDepositKey = (deposit: IStoreDeposit): IStoreDepositKey => ({
  storeCode: deposit.storeCode,
  cashRegister: deposit.cashRegister,
  operationDate: toIsoDate(deposit.operationDate),
  responsibleCode: deposit.responsibleCode,
  responsibleSequence: deposit.responsibleSequence,
  operationNumber: deposit.operationNumber,
  entrySequence: deposit.entrySequence,
});

/**
 * Identidade estável do depósito para uso como `key` de React: trocar o depósito
 * selecionado remonta o modal, e o estado do formulário nasce do depósito novo
 * em vez de ser sincronizado por efeito.
 */
export const depositIdentity = (deposit: IStoreDeposit): string =>
  Object.values(toDepositKey(deposit)).join(DEPOSIT_IDENTITY_SEPARATOR);
